// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-hprxy{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.assets-scss-gridstyleGrid-grid-brpyy{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-jgvtz{grid-column:span 6}.assets-scss-gridstyleGrid-col3-blyuq{grid-column:span 3}.assets-scss-gridstyleGrid-col4-mxhkz{grid-column:span 4}.assets-scss-gridstyleGrid-col9-bjeub{grid-column:span 9}.assets-scss-gridstyleGrid-col12-btzte{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-blpps{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-hprxy",
	"grid": "assets-scss-gridstyleGrid-grid-brpyy",
	"col6": "assets-scss-gridstyleGrid-col6-jgvtz",
	"col3": "assets-scss-gridstyleGrid-col3-blyuq",
	"col4": "assets-scss-gridstyleGrid-col4-mxhkz",
	"col9": "assets-scss-gridstyleGrid-col9-bjeub",
	"col12": "assets-scss-gridstyleGrid-col12-btzte",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-blpps"
};
module.exports = ___CSS_LOADER_EXPORT___;
